export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  views: number;
  slug: string;
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '《流浪地球3》票房突破50亿，中国科幻电影再创奇迹',
    summary: '上映仅两周，《流浪地球3》票房就突破了50亿大关，成为2026年最卖座的国产电影。这部科幻巨制不仅在国内取得骄人成绩，在海外市场也获得了广泛好评。',
    content: `<p>2026年最受期待的国产科幻大片《流浪地球3》自上映以来，票房一路高歌猛进。据猫眼专业版数据显示，截至7月30日，该片累计票房已突破50亿元人民币，成为中国影史票房榜第二名。</p>
<p>导演郭帆在接受采访时表示："《流浪地球3》是我们团队历时五年打造的作品，我们希望通过这部电影，让世界看到中国科幻电影的实力。"</p>
<p>该片在视觉效果上实现了全面升级，使用了全球领先的虚拟制片技术。影片中的太空场景和灾难场面令人叹为观止，IMAX版本的观影体验更是被誉为"中国科幻电影的新高度"。</p>
<p>海外市场方面，《流浪地球3》在北美、欧洲、东南亚等地区同步上映，首周末即在北美取得2800万美元的票房成绩，创下华语电影在北美的最佳开画纪录。</p>
<p>业内人士分析认为，《流浪地球》系列的成功不仅标志着中国科幻电影的成熟，更展现了中国电影工业整体实力的飞跃。</p>`,
    category: 'dianying',
    author: '影视观察员',
    date: '2026-07-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20news%20featured%20image%20with%20space%20theme%20and%20Earth%2C%20dramatic%20cinematic%20lighting%2C%20warm%20orange%20tones%2C%20professional%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a001&orientation=landscape',
    tags: ['流浪地球3', '票房', '科幻电影', '国产电影'],
    views: 25800,
    slug: 'liulang-diqiu-3-piaofang-50yi',
    isFeatured: true,
  },
  {
    id: 'a002',
    title: '深度解析：《三体：黑暗森林》为何成为年度最佳国剧',
    summary: '从剧情改编到视觉呈现，从演员表演到音乐特效，《三体：黑暗森林》在各个方面都达到了国产剧的新高度。本文将从多个维度深度解析这部现象级作品。',
    content: `<p>《三体：黑暗森林》自播出以来，便引发了全网热议。这部改编自刘慈欣同名小说的科幻剧集，不仅在豆瓣上获得了9.4的高分，更被多家媒体评为"年度最佳国产剧集"。</p>
<p>在剧情改编方面，编剧团队在忠实原著的基础上做了大胆创新。他们将罗辑这个角色的性格塑造得更加立体，增加了他与庄颜之间的感情线，让这个物理学家从"天才"变成了一个有血有肉的人。</p>
<p>视觉呈现是该剧的另一大亮点。制作团队采用了最先进的CGI技术和实景搭建相结合的方式，将三体世界的宏大场景——水滴、智子、末日战役等——栩栩如生地展现在观众面前。</p>
<p>演员方面，张译饰演的罗辑、段奕宏饰演的章北海等角色都给观众留下了深刻印象。尤其是老年叶文洁的扮演者陈瑾，她将一个经历了时代变迁、心怀复杂情感的角色演绎得入木三分。</p>
<p>可以说，《三体：黑暗森林》的成功，为中国科幻剧集树立了一个全新的标杆。</p>`,
    category: 'dianshiju',
    author: '剧评人李明',
    date: '2026-07-28',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmic%20sci-fi%20drama%20news%20image%20with%20universe%20and%20stars%2C%20dark%20mysterious%20atmosphere%2C%20deep%20blue%20tones%2C%20professional%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a002&orientation=landscape',
    tags: ['三体', '黑暗森林', '国产剧', '科幻', '剧评'],
    views: 31200,
    slug: 'santi-heian-senlin-shendu-jiexi',
    isFeatured: true,
  },
  {
    id: 'a003',
    title: '2026年暑期档：国产动画电影迎来井喷式发展',
    summary: '今年暑期档，多部国产动画电影相继上映，无论是票房还是口碑都取得了亮眼成绩。国产动画正在经历前所未有的黄金发展期。',
    content: `<p>2026年的暑期档，对于国产动画电影来说是一个里程碑式的时刻。《深海》、《西游记之大圣归来2》、《中国奇谭第二季》等多部作品相继上映，在票房和口碑上都取得了令人瞩目的成绩。</p>
<p>其中，《深海》凭借其独特的粒子水墨画风和深刻的情感内核，上映首周即斩获3.2亿票房。《西游记之大圣归来2》作为经典IP续作，延续了前作的高水准制作，累计票房已突破15亿。</p>
<p>业内人士指出，国产动画的崛起得益于以下几个因素：一是制作技术的不断进步，国产动画在视觉效果上已经达到国际一流水准；二是创作理念的更新，越来越多的动画作品开始探索更深层次的主题；三是市场环境的成熟，观众对国产动画的接受度和期待值都在持续提升。</p>
<p>光线传媒总裁王长田表示："国产动画正处在最好的时代。我们有优秀的创作人才，有成熟的技术储备，更有热情的市场。未来五年将是国产动画全面爆发的五年。"</p>`,
    category: 'dongman',
    author: '动漫评论家',
    date: '2026-07-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20news%20image%20with%20colorful%20art%20style%2C%20warm%20creative%20atmosphere%2C%20professional%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a003&orientation=landscape',
    tags: ['国产动画', '暑期档', '电影市场', '动漫'],
    views: 18600,
    slug: '2026-shuqi-dang-guoman-fazhan',
    isFeatured: true,
  },
  {
    id: 'a004',
    title: '《舌尖上的中国5》回归：美食纪录片何以持续走红',
    summary: '时隔四年，《舌尖上的中国》第五季重磅回归。这部被誉为"中国美食纪录片天花板"的作品，为何能够持续保持超高人气？',
    content: `<p>《舌尖上的中国》第五季于7月正式上线，首集播出即引发全网热议。这部由陈晓卿导演的美食纪录片系列，自2012年第一季播出以来，已经陪伴观众走过了十四个年头。</p>
<p>第五季延续了该系列一贯的高水准制作，但在选题和叙事上有了新的突破。摄制组走遍了中国34个省级行政区，不仅拍摄了人们熟悉的地方美食，更深入到了许多鲜为人知的小众美食文化中。</p>
<p>导演陈晓卿表示："美食只是我们的切入点，我们真正想展现的是食物背后的人、故事和情感。每一个地方的美食，都承载着那个地方的历史、文化和记忆。"</p>
<p>从豆瓣评分来看，《舌尖上的中国》系列一直保持着极高的口碑。第一季9.4分，第二季8.5分，第三季9.0分，第四季9.2分，而第五季开播即获得9.6分的高分。</p>
<p>美食纪录片的持续走红，也反映了当下观众对于高品质文化内容的需求。在这个快节奏的时代，人们越来越渴望通过美食找到与传统文化、与家乡记忆的连接。</p>`,
    category: 'jilupian',
    author: '文化观察者',
    date: '2026-07-22',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20news%20image%20with%20steaming%20dishes%2C%20warm%20appetizing%20colors%2C%20professional%20culinary%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a004&orientation=landscape',
    tags: ['舌尖上的中国', '美食', '纪录片', '文化'],
    views: 22300,
    slug: 'shejianshang-zhongguo-5-huigui',
    isFeatured: false,
  },
  {
    id: 'a005',
    title: '综艺节目的创新之路：《脱口秀大会8》如何破圈',
    summary: '走到第八季的《脱口秀大会》依然保持着旺盛的生命力。本文分析了这档长寿综艺节目是如何通过持续创新来保持观众新鲜感的。',
    content: `<p>《脱口秀大会》第八季正在热播中，这档已经走过八年的老牌综艺，依然保持着极高的话题热度和收视率。在综艺节目普遍面临审美疲劳的当下，《脱口秀大会》的持续成功值得关注。</p>
<p>本季节目的最大变化在于赛制创新。除了传统的脱口秀表演环节外，新增了"即兴挑战"和"命题创作"两个环节，让选手的创作能力和临场反应得到了更充分的展示。</p>
<p>选手阵容方面，本季既有呼兰、庞博、杨笠等老将回归，也有多位才华横溢的新人加入。新老选手的碰撞产生了不少火花，也让节目的内容更加丰富多元。</p>
<p>更值得关注的是，《脱口秀大会》在内容深度上的探索。从第一季的纯粹搞笑到如今对社会议题的深入探讨，节目在娱乐性和思想性之间找到了很好的平衡点。</p>
<p>总导演表示："我们希望《脱口秀大会》不仅是让观众笑的节目，更是能让观众思考的节目。好的脱口秀应该用幽默的方式讲真的话。"</p>`,
    category: 'zongyi',
    author: '综艺评论员',
    date: '2026-07-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20news%20image%20with%20microphone%20and%20stage%20lights%2C%20bright%20vibrant%20atmosphere%2C%20professional%20entertainment%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a005&orientation=landscape',
    tags: ['脱口秀大会', '综艺', '创新', '喜剧'],
    views: 16500,
    slug: 'tuokouxiu-dahui-8-poquan',
    isFeatured: false,
  },
  {
    id: 'a006',
    title: '苹果视频用户量突破1亿，免费影视平台迎来爆发期',
    summary: '苹果视频宣布其注册用户数突破1亿大关。作为国内领先的免费影视平台，苹果视频的成功折射出在线视频行业的深刻变革。',
    content: `<p>2026年8月1日，苹果视频正式宣布其全球注册用户数突破1亿。这一里程碑式的数字，标志着苹果视频已成为国内最具影响力的免费影视平台之一。</p>
<p>自2018年创立以来，苹果视频始终坚持以用户为中心的理念，通过提供海量免费高清影视资源和流畅的在线播放体验，赢得了广大用户的信赖和喜爱。</p>
<p>苹果视频CEO在内部信中写道："1亿用户不是终点，而是新的起点。我们将继续加大在内容和技术上的投入，为每一位用户提供更好的观影体验。"</p>
<p>在内容策略上，苹果视频采用了多元化的合作模式，与国内外多家影视制作公司建立了合作关系，确保平台内容的丰富性和时效性。同时，平台也积极布局自制内容，推出了多部口碑和流量俱佳的自制剧和综艺。</p>
<p>技术方面，苹果视频自主研发的视频压缩和传输技术，能够在保证画质的前提下大幅降低带宽消耗，让用户即使在网络条件不佳的情况下也能流畅观看高清视频。</p>
<p>行业分析师认为，随着用户对免费高品质内容需求的持续增长，以苹果视频为代表的免费影视平台将迎来更大的发展机遇。</p>`,
    category: 'pingtaidongtai',
    author: '科技记者',
    date: '2026-08-01',
    imageUrl: 'https://readdy.ai/api/search-image?query=Technology%20platform%20news%20image%20with%20modern%20office%20and%20data%20visualization%2C%20warm%20corporate%20atmosphere%2C%20professional%20editorial%20photography%20style%2C%20clean%20composition&width=600&height=338&seq=art-a006&orientation=landscape',
    tags: ['苹果视频', '用户量', '影视平台', '行业动态'],
    views: 45200,
    slug: 'pingguoshipin-yonghuliang-1yi',
    isFeatured: true,
  },
];